var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "dashboard-widget notification",
      class: _vm.status_class,
      attrs: { title: _vm.tooltip },
    },
    [
      _c("section", {
        staticClass: "dashbaord-status-value has-text-centerd",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "dashboard-widget-delta" }, [
        _c("small", {
          staticClass: "has-text-centered",
          domProps: { innerHTML: _vm._s(_vm.text_subtitle) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }